import request from '@/utils/request'

export function getContractDetail(params) {
    return request({
        url: '/v2/sec/contractDetail/getContractDetail',
        method: 'post',
        data: params
    })
}
export function downloadFile(params) {
    return request({
        url: '/v2/sec/contractDetail/downloadFile',
        method: 'post',
        data: params
    })
}
export function changeStatusForApprove(params) {
    return request({
        url: '/v2/sec/contractDetail/changeStatusForApprove',
        method: 'post',
        data: params
    })

}
export function changeStatus(params) {
    return request({
        url: '/v2/sec/contractDetail/changeStatus',
        method: 'post',
        data: params
    })
}
export function changeStatusForReviewApprove(params) {
    return request({
        url: '/v2/sec/contractDetail/changeStatusForReviewApprove',
        method: 'post',
        data: params
    })
}
export function validatePersonalPG(params) {
    return request({
        url: '/v2/sec/contractDetail/validatePersonalPG',
        method: 'post',
        data: params
    })
}
export function verifyChain(params) {
    return request({
        url: '/v2/sec/contractDetail/verifyChain',
        method: 'post',
        data: params
    })
}
export function emailRetry(params) {
    return request({
        url: '/v2/sec/contractDetail/emailRty',
        method: 'post',
        data: params
    })
}

export function getContractRecord(params) {
    return request({
        url: '/v2/sec/contractDetail/getContractRecord',
        method: 'post',
        data: params
    })
}

export function uploadFile(params) {
    return request({
        url: '/v2/sec/contractDetail/uploadFile',
        method: 'post',
        data: params
    })
}

export function sendAttachFile(params) {
    return request({
        url: '/v2/sec/contractDetail/sendAttachFile',
        method: 'post',
        data: params
    })
}

export function rejectContract(params) {
  return request({
    url: "/v2/sec/contractDetail/rejectContract",
    method: "post",
    data: params
  });
}
